<template>
  <div class="wrap">
    杭州焱虎网络科技有限公司 ｜ 浙江省杭州市西湖区西溪银泰商业中心2号楼北楼810室 ｜ 浙ICP备19046733号
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.wrap {
  width: 100%;
  height: 42px;
  background: #292120;
  margin-top: 8px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 42px;
  letter-spacing: 2px;
  text-align: center;
}
</style>